// Deprecated

'use strict';

module.exports = function (obj) { return typeof obj === 'function'; };



/*****************
 ** WEBPACK FOOTER
 ** /Users/bvaughn/Documents/git/react-devtools/~/es5-ext/object/is-callable.js
 ** module id = 45
 ** module chunks = 0
 **/